import { HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import {  IBizEntity, Units, UnitCategory, Unit, getCurrentDateTime} from '@optima-stride-ai/core';
import { LocalStorageService, OptimaAPPServer2Service, OptimaAPIHeaderService, StateStore, CachedDataCategories, CacheValidationService, iLocalStorageConfig, OptimaAPIs, ProgressIndicatorService, JsonLoaderService } from '@optima-stride-ai/optima-platform';
import { benzaitenAppHeaders, benzaitenAppServerURL } from '../../environments/environment';
import { convertIdArrayToQueryString } from '../../state/state-utils/utility';
import { UtilService } from '../../utils/util.service';
import { IProgressStatus } from '@optima-stride-ai/optima-app-framework';
import { IValues, Progression } from '@optima-stride-ai/optima-app-framework';


@Injectable({
  providedIn: 'root'
})
export class KpiProgressHistoryStateStoreService {
  private optimaAppServerService = inject(OptimaAPPServer2Service);

  private localStorageService = inject(LocalStorageService);
  private cacheInvalidationService = inject(CacheValidationService);
  private jsonLoaderService :JsonLoaderService = inject(JsonLoaderService);
  private progressIndicatorService: ProgressIndicatorService = inject(ProgressIndicatorService);
  private optimaAPIHeaderService = inject(OptimaAPIHeaderService);
  private optimaAPIs = inject(OptimaAPIs);
  //remove any done for temporary purpose only for testing 
  private KPIProgressHistoryStatusStore: StateStore<Record<string, IProgressStatus[]>> | undefined;
  private KPIProgressHistoryStatusStoreSingleStore: StateStore<IProgressStatus> | undefined;
  // private utilService = inject(UtilService);
  showDebugMessages = false;

  // private appServerURL = benzaitenAppServerURL;
  // private appHeaders = benzaitenAppHeaders;

  // private readonly apiHeaders : OptimaAPIHeaderValues = new OptimaAPIHeaderValues(this.appHeaders.tenantuuid, this.appHeaders.appid, this.appHeaders.userToken);

  private _dealWithDataLocally = false; //API will not be called, data will be generated locally from the mock data (if the shape of data is not in sync (server/local/app-logic), this might fail)
  
    constructor() {
      this.initialSetup();
    }
  
    set dealWithDataLocally(value: boolean) { this._dealWithDataLocally = value; }
  
  
    private initialSetup() {
      let localStoreConfig: iLocalStorageConfig = {
        localStorageService: this.localStorageService,
        discardLocalData: !this._dealWithDataLocally,
        // key: MockRemoteAPIStorageKeys.BenBizEntityProgressStatus,
        initialMockDataJSONAssetRelativePath: 'data/static/startup/test-tenant-two/biz-entity-type-test-tenant-two.json'
      };
      // this.optimaAPIHeaderService.optimaAPIHeaderValues = this.apiHeaders;
      this.KPIProgressHistoryStatusStore = new StateStore<Record<string, IProgressStatus[]>>(CachedDataCategories.All, this.optimaAppServerService, localStoreConfig, this.cacheInvalidationService, this.jsonLoaderService, (data) => { return true; },this.optimaAPIHeaderService, KPIProgressHistoryAPIDataTransformer, this.progressIndicatorService, true);
      this.KPIProgressHistoryStatusStore.showDebugMessages = this.showDebugMessages;
    }
  
    get changed() {
      return this.KPIProgressHistoryStatusStore?.changed;
    }
    
    getState(startDate:string = '2021-01-01 03:24:48', endDate:string = getCurrentDateTime(), KPIIds?: string[]) {
  
      if (!this.KPIProgressHistoryStatusStore) throw new Error("Store not initialized");
  
      if (this._dealWithDataLocally) {
        return this.KPIProgressHistoryStatusStore.getState()
      } else {
        return this.KPIProgressHistoryStatusStore.getState(
          {
            authRequired: true,
            apiEndPoint: this.optimaAPIs.KPIProgressHistoryStatus,
            apiParams: new HttpParams(
              {
                fromString: KPIIds || startDate || endDate ? convertIdArrayToQueryString(KPIIds || [], startDate, endDate) :''
              }
            ),
            fullURLWithParams: '',
            method: 'GET',
            headers: [],
            body: undefined
          }, "")
      }
    }
}

export function temporaryDataSyncBeforeSendingToAPI(data: IProgressStatus) : any{
   
}

export function KPIProgressHistoryAPIDataTransformer(data: any): Record<string, IProgressStatus[]> {
  const result: Record<string, IProgressStatus[]> = {};
  // Ensure data is a non-null object and not an array
  if (data && typeof data === 'object' && !Array.isArray(data)) {
    
    // Iterate over each ID key in the response object
    for (const id of Object.keys(data)) {
      const entry = data[id];
      const statusFieldName = entry.statusFieldName || 'status';
      const dataArray = entry.data || [];
      
      result[id] = dataArray.map((item: any) => {
        let unit: Unit | undefined;
        let date: Date = new Date();

        if (item.hasOwnProperty('date')) {
          date = new Date(item.date);
        }

        if (!item.hasOwnProperty('unitId')) {
          item.unitId = 25;
        }

        if (item.hasOwnProperty('unitId')) {
          unit = Units.find((unit) => unit.id.toString() === item.unitId.toString());
        }

        if (item.hasOwnProperty(statusFieldName)) {
          const rawActual = Number(item[statusFieldName]);
          const progressionValue: IValues = {
            minimum: 0,
            actual: isNaN(rawActual) ? item[statusFieldName] : Math.round(rawActual * 100) / 100
          };
          const actualProgression = new Progression(progressionValue, date, unit!);
          item.actual = [];
          item.actual.push(actualProgression);
        }

        const progressStatus: IProgressStatus = {
          actual: item.actual,
        };
        return progressStatus;
      });
    }
  }
  return result;
}
